import { render, staticRenderFns } from "./UpdateGeoData.vue?vue&type=template&id=2527165b&"
import script from "./UpdateGeoData.vue?vue&type=script&lang=js&"
export * from "./UpdateGeoData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports